import { api, getList } from "./api";
import type { GroupeFrigorifique } from "../types/groupefrigorifique";
import type { HistoriqueArretGroupeFrigorifique } from "../types/historiquearretgroupe";

// Récupérer tous les groupes frigorifiques
export async function getAllGroupesFrigorifiques(): Promise<GroupeFrigorifique[]> {
  return getList<GroupeFrigorifique>("/groupes-frigorifiques/");
}

// Créer un groupe frigorifique (FormData pour gérer la photo)
export async function createGroupeFrigorifique(formData: FormData): Promise<GroupeFrigorifique> {
  const res = await api.post("/groupes-frigorifiques/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

// Mettre à jour un groupe frigorifique (FormData pour gérer la photo)
export async function updateGroupeFrigorifique(id: string, formData: FormData): Promise<GroupeFrigorifique> {
  const res = await api.put(`/groupes-frigorifiques/${id}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

// Supprimer un groupe frigorifique
export async function deleteGroupeFrigorifique(id: string): Promise<void> {
  await api.delete(`/groupes-frigorifiques/${id}/`);
}

// ✅ Récupérer l’historique des arrêts pour un groupe frigorifique
export async function getHistoriqueGroupeFrigorifique(groupeId: string): Promise<HistoriqueArretGroupeFrigorifique[]> {
  return getList<HistoriqueArretGroupeFrigorifique>(`/groupes-frigorifiques/${groupeId}/historiques/`);
}
